import { takeEvery, put, call } from 'redux-saga/effects';
import { createEffect } from './creator';
import {
    NOTICE_GET_OVERVIEW,
    getOverview,
    NOTICE_SET_OVERVIEW,
    setOverview,
    NOTICE_GET_ALL_MANUAL_TYPE,
    getAllManualType,
} from '../actions/notice';
import NoticeApi from 'pc-sales/api.v2/notice';

export default [
    // 获取导航预览消息列表
    takeEvery(
        NOTICE_GET_OVERVIEW,
        createEffect(function* getSettingEffect(action: Action.Async): any {
            const { payload } = action;
            try {
                const data = yield call(NoticeApi.get, payload);
                yield put(getOverview.succeeded(data));
                return data;
            } catch (err) {
                throw err;
            }
        })
    ),
    // 更新通知数量
    takeEvery(
        NOTICE_SET_OVERVIEW,
        createEffect(function* getSettingEffect(action: Action.Async) {
            const { payload } = action;
            try {
                yield put(setOverview.succeeded(payload));
                return payload;
            } catch (err) {
                throw err;
            }
        })
    ),
    // 获取含有子级的所有通知类型列表
    takeEvery(
        NOTICE_GET_ALL_MANUAL_TYPE,
        createEffect(function* getSettingEffect(action: Action.Async): any {
            const { payload } = action;
            try {
                const data = yield call(NoticeApi.getAllManualType, payload);
                yield put(getAllManualType.succeeded(data));
                return data;
            } catch (err) {
                throw err;
            }
        })
    ),
];
